import {shallowEqual, useSelector} from 'react-redux';

//Components
import DetailQuickBookCard from './DetailQuickBookCard';

//Selectors
import {
  previousBookingDataSelector,
  searchRoomApiRequestSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {userSelector} from '@stencil/user-reducer';

export default function DetailPreviousBooking() {
  const previosuBookingData = useSelector(previousBookingDataSelector);
  const {isLoggedIn} = useSelector(userSelector);

  if (!isLoggedIn || !previosuBookingData || !previosuBookingData?.length) return null;

  return <>{<DetailQuickBookCard data={previosuBookingData} />}</>;
}
